import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login'
import Index from '@/components/index'
import Order from '@/components/order'
import Reserve from '@/components/reserve'
import Hospital from '@/components/hospital'
import Success from '@/components/success'
import City from '@/components/city'
import Calendar from '@/components/calendar'
import Hospinfo from '@/components/hospinfo'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
      meta: {
        title: '预约记录'
      }
    },
    {
      path: '/reserve',
      name: 'reserve',
      component: Reserve,
      meta: {
        title: 'HPV疫苗预约'
      }
    },
    {
      path: '/hospital',
      name: 'hospital',
      component: Hospital,
      meta: {
        title: '门诊预约'
      }
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
      meta: {
        title: '预约成功'
      }
    },
    {
      path: '/city',
      name: 'city',
      component: City,
      meta: {
        title: '选择地区'
      }
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: Calendar,
      meta: {
        title: '选择日期'
      }
    },
    {
      path: '/hospinfo',
      name: 'hospinfo',
      component: Hospinfo,
      meta: {
        title: '选择医院'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js